/* eslint-disable @typescript-eslint/no-explicit-any */
import { datadogLogs } from '@datadog/browser-logs'

export function reportErrorToDatadog(error: Error, context?: Record<string, any>) {
  datadogLogs.logger.error(error.message, {
    error: {
      kind: error.name,
      stack: error.stack,
    },
    ...context,
  })
}
